import { render, staticRenderFns } from "./ActionsCard.htm?vue&type=template&id=0ddf509e&scoped=true&"
import script from "./ActionsCard.ts?vue&type=script&lang=js&"
export * from "./ActionsCard.ts?vue&type=script&lang=js&"
import style0 from "./ActionsCard.scss?vue&type=style&index=0&id=0ddf509e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf509e",
  null
  
)

export default component.exports